const LOGO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_partner-portal-207/artifacts/3ik5lroo_Logo%20Signature.png";

export const Logo = ({ className = "h-9" }) => (
  <img
    src={LOGO_URL}
    alt="Interlocked Solutions Limited"
    className={`${className} w-auto object-contain select-none`}
    draggable="false"
  />
);
